import dayjs from "dayjs";
import {Coupon} from "../../../../interfaces/Coupon";
import useQueryApiClient from "utils/useQueryApiClient";
import {useAuth} from "../../../../hooks/useAuth";

type QueryResult = ReturnType<typeof useQueryApiClient>

export function useCoupon(id?: number, onLoad?: (coupon: Coupon) => void): QueryResult {
  const { user } = useAuth()
  const farmId = user?.farmId

  return useQueryApiClient({
    request: {
      url: id ? `api/v2/farms/${farmId}/coupons/${id}` : `api/v2/farms/${farmId}/coupons`,
      disableOnMount: !id,
    },
    onSuccess: (coupon: Coupon) => {
      coupon.start_date = coupon.start_date ? dayjs(coupon.start_date) : '';
      coupon.end_date = coupon.end_date ? dayjs(coupon.end_date) : '';
      onLoad?.(coupon);
    },
  })
}